import React, { useEffect, useState } from 'react';
import { XIcon } from './icons';

export interface ToastProps {
  id: string;
  message: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
  onDismiss: (id: string) => void;
}

export const Toast: React.FC<ToastProps> = ({ id, message, type = 'info', duration = 5000, onDismiss }) => {
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDismiss();
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onDismiss]);

  const handleDismiss = () => {
    setIsFadingOut(true);
    setTimeout(() => onDismiss(id), 300); // Wait for fade-out animation
  };

  const getBgColor = () => {
    switch (type) {
      case 'success': return 'bg-emerald-900/80 border-emerald-500/50';
      case 'error': return 'bg-red-900/80 border-red-500/50';
      default: return 'bg-surface border-primary';
    }
  };

  return (
    <div
      className={`
        w-full max-w-sm p-4 rounded-lg shadow-lg ${getBgColor()} border 
        flex items-center justify-between
        transition-all duration-300 ease-in-out
        backdrop-blur-md
        ${isFadingOut ? 'opacity-0 transform translate-y-2' : 'opacity-100 transform translate-y-0'}
      `}
      role="alert"
      aria-live="assertive"
    >
      <p className="text-text-main">{message}</p>
      <button
        onClick={handleDismiss}
        className="p-1 rounded-full text-text-secondary hover:bg-surface-light hover:text-text-main"
        aria-label="Benachrichtigung schließen"
      >
        <XIcon className="w-4 h-4" />
      </button>
    </div>
  );
};